// create audience api
import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getReportParticipantInfo: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info`,
  },
  getParticipantReport: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info-report`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getReportParticipantInfo = async (presentationId, participantId) => {
  const res = await resource.getReportParticipantInfo({ participantId, presentationId })
  return res.body
}

// payload: { presentationId, participantId, audienceIdTemp, presentationIdTemp, switchPresentationAudience }
const getParticipantReport = async (payload) => {
  const res = await resource.getParticipantReport(payload)
  return res.body?.participantAnswers
}

export default {
  initResource,
  getReportParticipantInfo,
  getParticipantReport,
}
